import { render, staticRenderFns } from "./imprimir_Problema.vue?vue&type=template&id=baa94d52&"
import script from "./imprimir_Problema.vue?vue&type=script&lang=ts&"
export * from "./imprimir_Problema.vue?vue&type=script&lang=ts&"
import style0 from "./imprimir_Problema.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports